// Resolves a pick image value to a full, renderable URL.
// - Absolute URLs (http/https) are returned as-is (e.g., seeded Unsplash images).
// - Relative API paths (e.g., "/api/files/...") are prefixed with the backend URL.
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export default resolveImageUrl;
